import {Snackbar} from "@mui/material";
import {Toast} from "@kaltura/ds-react-components";
import {useEffect, useState} from "react";
import { translate } from "@mediaspace/shared/utils";

export type NotificationMessageProps = {
    show: boolean;
    onClose: () => void;
    success: boolean;
    subscribed: boolean;
}

/**
 *  subscribe notification message
 */
const NotificationMessage = (props: NotificationMessageProps) => {

    const {show, onClose, success, subscribed} = props;

    const [notificationMessage, setNotificationMessage] = useState<string>("");


    const setText = () => {
        if (success) {
            return subscribed ?
                translate("You have subscribed to the channel.") :
                translate("You have been unsubscribed from channel.");
        } else {
            return !subscribed ?
                translate("Error subscribing to the channel.") :
                translate("Error unsubscribing from channel.");
        }
    }

    useEffect(() => {
        setNotificationMessage(setText());
    }, [success, subscribed, setText])

    return (
        <Snackbar open={show} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Toast
                onClose={onClose}
                severity={success ? "success" : "error"}
            >
                <span>{notificationMessage}</span>
            </Toast>
        </Snackbar>
    )
};

export default NotificationMessage;
